
import wx from "weixin-js-sdk";
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import global_ from '../global'

export default {
name: "Pay",
components: {Group, XButton, PopupRadio, CheckIcon, Checker, CheckerItem, XInput},
data() {
return {
paymethod: ['微信支付', '零钱支付', '线下支付'],
method: '微信支付',
opid: localStorage.getItem('userid'),
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
seq: this.$route.query.seq,
issue: false,
img: '/static/img/bill.png',
bill: '',
invoiceTitle: '',
invoiceType: '',
invoice: {
content: {
company: '',
taxNumber: '',
bank: '',
bankAccount: '',
address: '',
tel: ''
},
type: ''
},
}
},
methods: {
pay() {
switch (this.method) {
case '微信支付':
if (this.issue) {
if (this.invoiceTitle === 2) {
if ((this.invoice.content.company === '') || (this.invoice.content.taxNumber === '')) {
this.$vux.alert.show({
title: '',
content: '请补全发票信息后再提交'
})
return
}
}
if (this.invoiceType === 2) {
if ((this.invoice.content.bank === '') || (this.invoice.content.bankAccount === '') || (this.invoice.content.address === '') || (this.invoice.content.tel === '')) {
this.$vux.alert.show({
title: '',
content: '请补全发票信息后再提交'
})
return
}
}
if (this.invoiceType === 1) {
this.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit'
} else {
this.invoice.type = 'VatSpecialInvoice'
}
}
this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_wx', {
role: 'INDV',
issue: this.issue ? 'True' : 'False',
openid: localStorage.getItem('openid'),
user_ip: '127.0.0.1',
invoice_detail: this.issue ? this.invoice : null
}, this.header).then(response => {
wx.chooseWXPay({
timestamp: response.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: response.data.nonceStr, // 支付签名随机串，不长于 32 位
package: response.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
signType: response.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: response.data.paySign, // 支付签名
success: (res) => {
console.log(res)
this.$router.push({name: 'Payinfo', query: {seq: this.seq,role:'INDV'}})
},
fail: (err) => {
console.log(err)
}
})
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
break
case '零钱支付':
this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_change', {
role: 'INDV'
}, this.header).then(() => {
this.$vux.toast.show({
text: '交易成功',
type: 'success',
time: '1000'
})
this.$router.push({name: 'Payinfo', query: {seq: this.seq,role:'INDV'}})
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
break
case '线下支付':
if (this.issue) {
if (this.invoiceTitle === 2) {
if ((this.invoice.content.company === '') || (this.invoice.content.taxNumber === '')) {
this.$vux.alert.show({
title: '',
content: '请补全发票信息后再提交'
})
return
}
}
if (this.invoiceType === 2) {
if ((this.invoice.content.bank === '') || (this.invoice.content.bankAccount === '') || (this.invoice.content.address === '') || (this.invoice.content.tel === '')) {
this.$vux.alert.show({
title: '',
content: '请补全发票信息后再提交'
})
return
}
}
if (this.invoiceType === 1) {
this.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit'
} else {
this.invoice.type = 'VatSpecialInvoice'
}
}

this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_bank', {
role: 'INDV',
issue: this.issue ? 'True' : 'False',
invoice_detail: this.issue ? this.invoice : null,
bill_photo: this.bill
}, this.header).then(() => {
this.$vux.toast.show({
text: '交易成功',
type: 'success',
time: '1000'
})
this.$router.push({name: 'Payinfo', query: {seq: this.seq,role:'INDV'}})
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
break
}
},
upload() {
wx.chooseImage({
count: 1, // 默认9
sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: (res) => {
let localIds = res.localIds 
this.img = localIds[0]
if (window.__wxjs_is_wkwebview) {
wx.getLocalImgData({
localId: localIds[0],
success: (res) => {
this.img = res.localData
}
})
}
setTimeout(
wx.uploadImage({
localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: (res) => {
let serverId = res.serverId 
this.$http.get('/api/v1/payments/' + this.opid + '/orders?type=bill&serverid=' + serverId, this.header)
.then((response) => {
this.bill = response.data[0]
})
.catch((error) => {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
}), 100)
}
})
}
},
mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
this.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {
url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.fullPath
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then((response) => {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi'] 
})
wx.error(function (res) {
alert(res.errMsg)
})
})
.catch(function (error) {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
}
}



// WEBPACK FOOTER //
// ./src/components/Pay/Pay.vue